import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import { setProduct } from '../store/productSlice'
import PdpGallery from "./PdpGallery.jsx"
import PdpZoom from "./PdpZoom.jsx"
// import OosPoup from "./OosPoup.jsx"

document.addEventListener('DOMContentLoaded', () => {
  const pdpContainer = document.querySelector('[data-section-type="main-product"]')
  if(pdpContainer) {
    const pathHandle = pdpContainer.dataset.handle
    const jsonData = JSON.parse(pdpContainer.querySelector('[data-products-json]').innerHTML)
    store.dispatch(setProduct(jsonData.filter((product) => product.handle == pathHandle)[0]))
  }

  // PDP Gallery
  const galleryWrapper = document.querySelector('[data-pdp-gallery]')
  if(galleryWrapper) {
    const galleryRoot = createRoot(galleryWrapper)
    galleryRoot.render(<Provider store={store}><PdpGallery /></Provider>)
  }

  // PDP ZOOM Popup
  const zoomWrapper = document.querySelector('[data-media-zoom]')
  if(zoomWrapper) {
    const zoomRoot = createRoot(zoomWrapper)
    zoomRoot.render(<Provider store={store}><PdpZoom /></Provider>)
  }

  // PDP OOS
  // const oosWrapper = document.querySelector('[data-oos-popup]')
  // const oosRoot = createRoot(oosWrapper)
  // oosRoot.render(<Provider store={store}><OosPoup /></Provider>)
})